const publishedSharedRouteRegex = /(\/storymap\/shared\/)([^\/?#]+)/gi;
const serializedAccessKeyRegex = /("(?:AccessKey|accessKey|publishedAccessKey)"\s*:\s*)"([^"]*)"/g;
const publishedAccessFieldNames = ['AccessKey', 'accessKey', 'publishedAccessKey'];
// Recipient attachment tokens of delivered /dl and /dlthumbnail URLs (raw and URL-encoded '='). publicattachment carries
// a non-secret map selector and is intentionally not masked; empty (OFF) values and already redacted values stay as they are.
// pictureAccessKey is the browsing key of persona picture addresses of published maps (private-link token or public slug).
const recipientAttachmentTokenRegex = /((?:ngattachment|classicattachment|pictureAccessKey)=)(?!\[redacted)([^&#\s"'<>)\]\\]+)/gi;
const encodedRecipientAttachmentTokenRegex = /((?:ngattachment|classicattachment|pictureAccessKey)%3D)(?!%5Bredacted|\[redacted)((?:(?!%26|%23|%22|%20)[^&#\s"'\\])+)/gi;

export const redactedPublishedAccessValue = '[redacted]';

export function redactPublishedAccess(value: string): string;
export function redactPublishedAccess<T>(value: T): T;
export function redactPublishedAccess<T>(value: T): T {
    if (typeof value == 'string') {
        return redactPublishedAccessString(value) as T;
    }

    if (value == null || typeof value != 'object') {
        return value;
    }

    return JSON.parse(JSON.stringify(value, publishedAccessReplacer));
}

function publishedAccessReplacer(key: string, value: any): any {
    if (isPublishedAccessFieldName(key)) {
        return redactPublishedAccessSecret(value);
    }

    if (typeof value == 'string') {
        return redactPublishedAccessString(value);
    }

    return value;
}

function redactPublishedAccessString(value: string): string {
    if (!value) {
        return value;
    }

    return value
        .replace(publishedSharedRouteRegex, (_, prefix, token) => `${prefix}${redactPublishedAccessSecret(token)}`)
        .replace(serializedAccessKeyRegex, (_, prefix, token) => `${prefix}"${redactPublishedAccessSecret(token)}"`)
        .replace(recipientAttachmentTokenRegex, (_, prefix, token) => `${prefix}${redactPublishedAccessSecret(token)}`)
        .replace(encodedRecipientAttachmentTokenRegex, (_, prefix, token) => `${prefix}${redactPublishedAccessSecret(token)}`);
}

function isPublishedAccessFieldName(key: string): boolean {
    return publishedAccessFieldNames.indexOf(key) >= 0;
}

function redactPublishedAccessSecret(value: any): string {
    if (typeof value != 'string' || !value) {
        return redactedPublishedAccessValue;
    }

    return `[redacted:${createRedactionId(value)}]`;
}

function createRedactionId(value: string): string {
    let hash = 2166136261;
    for (let i = 0; i < value.length; i++) {
        hash ^= value.charCodeAt(i);
        hash = Math.imul(hash, 16777619);
    }

    return (hash >>> 0).toString(16).padStart(8, '0');
}
